(() => {
  if (window.patriCatalogReady) return;
  window.patriCatalogReady = true;
  const instances = new Map();
  const initialize = () => {
    document.querySelectorAll('[data-patri-catalog]').forEach(catalog => {
      if (catalog.dataset.catalogReady) return;
      catalog.dataset.catalogReady = 'true';
      instances.get(catalog.id)?.abort();
      const controller = new AbortController();
      instances.set(catalog.id, controller);
      const options = {signal:controller.signal};
      const items = [...catalog.querySelectorAll('[data-catalog-item]')];
      const filters = catalog.querySelector('[data-catalog-filters]');
      const status = catalog.querySelector('[data-catalog-status]');
      const empty = catalog.querySelector('[data-catalog-empty]');
      const groups = new Map();
      items.forEach(item => {
        if (item.dataset.catalogGroup) groups.set(item.dataset.catalogGroup, item.dataset.catalogLabel);
      });
      for (const [key, label] of groups) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'patri-catalog-filter';
        button.dataset.catalogFilter = key;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = label;
        filters.append(button);
      }
      catalog.querySelector('[data-catalog-tools]').hidden = false;
      filters.hidden = catalog.dataset.showFilters === 'false' || !groups.size;
      const apply = key => {
        let count = 0;
        items.forEach(item => {
          item.hidden = Boolean(key && item.dataset.catalogGroup !== key);
          if (!item.hidden) count += 1;
        });
        filters.querySelectorAll('[data-catalog-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.catalogFilter === key)));
        status.textContent = `${groups.has(key) ? groups.get(key) + ' · ' : ''}${count} ${count === 1 ? status.dataset.singularLabel : status.dataset.countLabel}`;
        empty.hidden = count !== 0;
      };
      const readUrl = () => apply(new URL(window.location.href).searchParams.get('categoria') || '');
      const choose = (key, focusHeading = false) => {
        const url = new URL(window.location.href);
        if (key) url.searchParams.set('categoria', key);
        else url.searchParams.delete('categoria');
        url.hash = catalog.id;
        if (url.href !== window.location.href) history.pushState(null, '', url);
        apply(key);
        if (focusHeading) {
          catalog.querySelector('h2').focus({preventScroll:true});
          catalog.scrollIntoView({behavior:'instant', block:'start'});
        }
      };
      catalog.addEventListener('click', event => {
        const filter = event.target.closest('[data-catalog-filter]');
        if (filter) choose(filter.dataset.catalogFilter);
        if (event.target.closest('[data-catalog-reset]')) choose('', true);
      }, options);
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#' + catalog.id || !url.searchParams.has('categoria')) return;
        event.preventDefault();
        choose(url.searchParams.get('categoria'), true);
      }, options);
      window.addEventListener('popstate', readUrl, options);
      document.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-catalog-item]');
        if (item && catalog.contains(item)) apply('');
      }, options);
      readUrl();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-patri-catalog]').forEach(catalog => {
      instances.get(catalog.id)?.abort();
      instances.delete(catalog.id);
    });
  });
})();
